<template>
  <div class="flex flex-col items-center justify-center">
    <nuxt-img
      class="flex w-[220px]"
      src="/images/search/not-found.webp"
      alt="not-found"
      sizes="xs:220px"
    />
    <h3
      class="mb-2 mt-7 text-center text-2xl font-semibold capitalize text-primary-700"
    >
      {{ $t("No results found") }}
    </h3>
    <span class="max-w-[400px] text-center text-lg text-[#052955]">
      {{
        $t(
          "Please try different keywords or browse our categories to find what you’re looking for",
        )
      }}
    </span>
  </div>
</template>
